import React, {useState} from 'react';

const defaultSubentity = {subentity:"", examples:[]}
const defaultFrase = { phrase: "", trained: false }

const EntityForm = ({entity,entities,guardarEntity,history, editing}) => {
    const [nuevoEntity,setNuevoEntity] = useState(entity);
    const entityLengthValidation = nuevoEntity.entity.length === 0
    const entityDuplicateValidation = entities.find(entity => entity.entity === nuevoEntity.entity) !== undefined
    return(
        <div style={{width:'80%',margin:'40px auto'}}>
            <div align="right">
                <div className='taby'>
                    {editing ? 'Editar' : 'Crear'} Entity
                </div>
            </div>
            <div className='form-container'>
                {editing ? 
                    <h1>{entity.entity}</h1> 
                : 
                    <>{ entityDuplicateValidation && <><small style={{color:'red'}}>Ese entity ya existe</small><br/></>}
                    <b>Entity </b>
                        <input onChange={(e)=>setNuevoEntity({...nuevoEntity, entity: e.target.value})}
                            value={nuevoEntity.entity} style={{fontSize:'large'}}
                        ></input>
                    <br/>
                    </>
                }        
                <b>Subentities</b>
                {nuevoEntity.subentities.map((subentity,index) => 
                    <div key={index} style={{border: '3px solid #253646', padding: 20}}>
                    <input onChange={(e)=>setNuevoEntity({...nuevoEntity, subentities:[...nuevoEntity.subentities.slice(0,index),{...subentity, subentity: e.target.value},...nuevoEntity.subentities.slice(index+1)]})}
                        value={subentity.subentity}  style={{width:'90%',marginTop:10}}
                    />
                    <button onClick={()=>setNuevoEntity({...nuevoEntity, subentities:[...nuevoEntity.subentities.slice(0,index),...nuevoEntity.subentities.slice(index+1)]})}
                        className='remove-button'>
                        x
                    </button>
                    <b style={{marginLeft:20}}>Ejemplos</b>
                    <div style={{margin: 40,marginTop: 10}}>
                        {subentity.examples.map( (example, index2) =>{
                            return(
                            <div key={index2}>
                                <input onChange={(e)=>setNuevoEntity({...nuevoEntity, subentities:[...nuevoEntity.subentities.slice(0,index),{...subentity, examples: [...nuevoEntity.subentities[index].examples.slice(0,index2),{...example, phrase: e.target.value},...nuevoEntity.subentities[index].examples.slice(index2+1)]},...nuevoEntity.subentities.slice(index+1)]})}
                                    value={example.phrase}  style={{width:'90%',marginTop:10}}
                                />
                                <button onClick={()=>setNuevoEntity({...nuevoEntity, subentities:[...nuevoEntity.subentities.slice(0,index),{...subentity, examples: [...nuevoEntity.subentities[index].examples.slice(0,index2),...nuevoEntity.subentities[index].examples.slice(index2+1)]},...nuevoEntity.subentities.slice(index+1)]})}
                                    className='remove-button'>
                                    x
                                </button>
                            </div>
                        )})}
                        <button onClick={()=>setNuevoEntity({...nuevoEntity, subentities:[...nuevoEntity.subentities.slice(0,index),{...subentity, examples: [...nuevoEntity.subentities[index].examples, defaultFrase]},...nuevoEntity.subentities.slice(index+1)]})}
                            className='add-button rectangle'>
                            +
                        </button>
                    </div>
                    </div>)
                    }
                <button onClick={()=>setNuevoEntity({...nuevoEntity, subentities:[...nuevoEntity.subentities, defaultSubentity]})}
                    className='add-button rectangle'>
                    +
                </button>
                <div className='form-actions' align="right">
                    <button className='form-button secondary-button'
                        onClick={()=>history.push("/training")}
                    >Cancelar</button>
                    <button disabled={entityLengthValidation || (!editing && entityDuplicateValidation)}
                        onClick={()=>guardarEntity(nuevoEntity)}  className='form-button primary-button'
                    >Guardar</button>
                </div>
            </div>
        </div>
    )
}

export default EntityForm